import { useEffect, useState } from "react";
import { subscribeScroll } from "@/lib/scrollEngine";

export function useScrollProgress() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    return subscribeScroll(() => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      setProgress(docHeight > 0 ? scrollTop / docHeight : 0);
    });
  }, []);

  return progress;
}
